import * as PropTypes from 'prop-types';

import DrinkFoodIcon from './DrinkFoodIcon';
import InfoIcon from './InfoIcon';
import OffscreenIcon from './OffscreenIcon';
import PartnersIcon from './PartnersIcon';

const icons = {
    // eslint-disable-next-line camelcase
    drink_food: DrinkFoodIcon,
    info: InfoIcon,
    offscreen: OffscreenIcon,
    partners: PartnersIcon,
};

const iconTypes = Object.keys(icons);

const Icon = ({ type, ...props }) => {
    if (!iconTypes.includes(type)) {
        // eslint-disable-next-line no-console
        console.error(`Type "${type}" is not included in the icon types.`);
        return null;
    }
    const Component = icons[type];
    return <Component {...props} />;
};

Icon.propTypes = {
    type: PropTypes.oneOf(Object.keys(icons)).isRequired,
};

export default Icon;
